import React, { useEffect, useState } from "react";
import EventModal from "../../../../features/plan/components/EventModal";
import { getFullName } from "../../../util/helpers";

const Event = (props) => {
  const { activeEvent, removeEvent, submit, cancel, visible, mode } = props;
  const [temporaryActiveEvent, setTemporaryActiveEvent] = useState(null);

  useEffect(() => {
    setTemporaryActiveEvent(activeEvent);
  }, [activeEvent]);

  const submitEvent = (e) => {
    submit(temporaryActiveEvent);
  };

  const handleCancel = (e) => {
    cancel();
  };

  const handleRemove = (e) => {
    removeEvent(temporaryActiveEvent);
  };

  const onChosenEmployee = (employee) => {
    const client_salary_tariff_id =
      activeEvent?.order?.client?.salary_tariff_id;
    const employeeName = employee
      ? getFullName(employee["surename"], employee["first_name"])
      : "";
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      employee: employee,
      employee_id: employee.id,
      employeeName: employeeName,
      title: employeeName,
      tariff_id: client_salary_tariff_id || employee.tariff_id,
      oncall: false,
      use_employee_tariff:
        client_salary_tariff_id || employee?.tariff ? true : false,
    });
  };

  const onRemoveEmployee = () => {
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      employee: null,
      employee_id: null,
      tariff_id: null,
      employeeName: null,
      title: null,
    });
  };

  const onTariffChanged = (val) => {
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      tariff_id: val,
    });
  };

  const onUseEmployeeTariffChanged = (val) => {
    const clientTariffId =
      temporaryActiveEvent?.order?.client?.salary_tariff_id;
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      use_employee_tariff: val,
      tariff_id: clientTariffId | temporaryActiveEvent?.employee?.tariff?.id,
    });
  };

  const onTransportationChanged = (val) => {
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      transportation_cost: val,
    });
  };

  const onOncallChange = (val) => {
    setTemporaryActiveEvent({
      ...temporaryActiveEvent,
      oncall: val,
    });
  };

  const changeActiveEvent = (changed) => {
    setTemporaryActiveEvent(changed);
  };

  return (
    <EventModal
      orders={[{ ...activeEvent.order, patient: activeEvent.patient }]}
      type="replacements"
      fromReplacements={true}
      activeEvent={temporaryActiveEvent}
      activeEventDay={temporaryActiveEvent && temporaryActiveEvent.weekday}
      visible={visible}
      submitEvent={submitEvent}
      handleCancel={handleCancel}
      removeEvent={handleRemove}
      mode={mode}
      changeActiveEvent={changeActiveEvent}
      onChosenEmployee={onChosenEmployee}
      onRemoveEmployee={onRemoveEmployee}
      onTariffChanged={onTariffChanged}
      onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
      onTransportationChanged={onTransportationChanged}
      onOncallChange={onOncallChange}
      patient={activeEvent.patient}
    />
  );
};

export default Event;
